import Board from "react-trello"
import { CardBoard } from "../Card"
import { LaneBoard } from "../Lane"
import { LoadingWithLabel } from "../../Loading"
import "./styles.scss";
import ScrollableLane from "../../ReactTrello/Virtualized/ScrollableLane";

const KanbanPlanning = ({ data, isInitialLoading, openModalTaskDetails, onDragEnd }) => {
  return (
    <>
      {isInitialLoading ? (
        <div className="kanban-content-loading">
          <LoadingWithLabel
            labelLoading="Buscando listas, aguarde..."
            sizeSpinner="large"
            colorSpinner="primary"
          />
        </div>
      ) : data && data?.lanes?.length > 0 ? (
        <Board
          components={{
            ScrollableLane: ScrollableLane,
            Card: (props) => {
              return <CardBoard onCardClick={(cardId) => openModalTaskDetails(cardId)} {...props} />
            },
            LaneHeader: (props) => {
              return <LaneBoard {...props} />
            },
          }}
          data={data}
          handleDragEnd={onDragEnd}
          className="impactools-card-board"
        />
      ) : (
        <div className="kanban-content-loading">Sem dados</div>
      )}
    </>
  )
}

export default KanbanPlanning
